import React, { useState } from 'react';
import {
    required,
    Button,
    useNotify,
    useRefresh,
    Form,
    useGetRecordId,
    CreateBase,
    DateInput,
    TextInput,
    useRecordContext,
    FormDataConsumer,
    useDataProvider
} from 'react-admin';
import { Box } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import { useMediaQuery } from '@mui/material';
import { useMutation } from 'react-query';


function AnnotationDialog() {
    const [showDialog, setShowDialog] = useState(false);

    const recordId = useGetRecordId()
    const record = useRecordContext()
    const title = `Adicionar evento para ${record.client_name}`
    const today = new Date().toISOString().slice(0, 10)

    const postDefaultValue = () => ({ client_id: recordId });

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };
    const notify = useNotify();

    const AddAnnotationButton = ({ client_id, event_date, annotation }) => {
        const dataProvider = useDataProvider();
        const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
        const refresh = useRefresh();
        const { mutate, isLoading } = useMutation(
            () => dataProvider.addAnnotation(`clients/add_annotation`, {
                data: {
                    "id": client_id,
                    "event_date": event_date,
                    "annotation": annotation,
                }
            }),
            {
                onSuccess: () => {
                    notify('ra.notification.add_annotation', { type: 'success' });
                    handleCloseClick()
                    refresh()
                },
                onError: (error) => {
                    notify(error.body.detail.event_date, { type: 'error' })
                }
            }
        );

        return (
            <>
                {isSmall ? (
                    <Button
                        label="Adicionar evento"
                        type="submit"
                        onClick={() => mutate()}
                        disabled={isLoading}
                        variant="outlined"
                        color="primary"
                        startIcon={<EventAvailableOutlinedIcon />}
                    />
                ) : (
                    <Button
                        label="Adicionar evento"
                        type="submit"
                        onClick={() => mutate()}
                        disabled={isLoading}
                        variant="outlined"
                        color="primary"
                        startIcon={<EventAvailableOutlinedIcon />}
                    />
                )}
            </>
        )
    }

    // The dialog
    return (
        <>
            <Box sx={{
                maxWidth: '16rem',
                marginTop: '3rem',
                marginBottom: '1rem',
            }}>
                <Button onClick={handleClick} label="ra.action.add_annotation"
                    variant="contained"
                    color="primary"
                    startIcon={<EventAvailableOutlinedIcon />}
                    sx={{
                        minHeight: '2.5rem',
                    }}
                />
            </Box>

            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label="ra.action.add_annotation"
            >
                <DialogTitle>{title}</DialogTitle>
                <CreateBase resource='clients/add_annotation'>
                    <Form defaultValues={postDefaultValue}
                    >
                        <DialogContent>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                            }} >
                                <DateInput source="event_date" label="resources.clients.event_date" defaultValue={today} validate={required()}
                                    onKeyDown={event => {
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            event.stopPropagation();
                                        }
                                    }}
                                />
                            </Box>
                            <Box>
                                <TextInput source='annotation' label="resources.clients.annotation" fullWidth />
                            </Box>

                        </DialogContent>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'flex-start',
                            justifyContent: 'space-around',
                            flexWrap: 'wrap',
                        }} >
                            <DialogActions>
                                <Button
                                    sx={{ marginRight: "3rem" }}
                                    label="ra.action.cancel"
                                    onClick={handleCloseClick}
                                >
                                    <IconCancel />
                                </Button>
                                <FormDataConsumer>
                                    {({ formData }) =>
                                        <AddAnnotationButton
                                            event_date={formData.event_date}
                                            annotation={formData.annotation}
                                            client_id={formData.client_id} />
                                    }
                                </FormDataConsumer>
                            </DialogActions>
                        </Box>
                    </Form>
                </CreateBase>
            </Dialog>
        </>
    );
}

export default AnnotationDialog;
